var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.descricao
    ? _c(
        "div",
        { staticClass: "mt-2" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "descricao-pratica" },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.descricao) } })
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [_vm._v("Descrição")]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-492cd81c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492cd81c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Descricao.vue
// module id = null
// module chunks = 